import { useEffect, useRef, useState } from "react";
import servicosSolicitacao from "../servicos/servicos-solicitacao";
import { useContext } from "react";
import AuthContext from "../servicos/autorizacao/AuthContex";
import Form from 'react-bootstrap/Form';
import NavMenu from "./components/Nav";
import NavMobile from "./components/NavMobile";
import { Modal } from "react-bootstrap";
import Cancel from "../img/svgs/Cancel";
import Salvar from "../img/svgs/Salvar";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../utils/localizedTextsMap";
import Edit from "../img/svgs/Edit";


const MinhasSolicitacoes = () => {
  const { user } = useContext(AuthContext);
  const [minhasSolicitacoes, setMinhasSolicitacoes] = useState([]);
  const [solicitacao, setSolicitacao] = useState();
  const [editado, setEditado] = useState();
  const [show, setShow] = useState(false);
  const [showObservacao, setShowObservacao] = useState(false);
  const containerRef = useRef(null);
  const handleClose = () => setShow(false);
  const handleCloseObservacao = () => setShowObservacao(false);
  const motivo_cancelamento = useRef();
  const [motivoVazio, setMotivoVazio] = useState(false);

  useEffect(() => {
    servicosSolicitacao.minhasSolicitacoes(user.id)
      .then(response => {
        if (response.status === 200) {
          setMinhasSolicitacoes(response.data);
        }
      }).catch(error => {
        console.log(error);
      })
  }, [editado, user.id])

  const handleShow = (solicitacao) => {
    setSolicitacao(solicitacao);
    setShow(true);
  }
  const handleShowObservacao = (solicitacao) => {
    setSolicitacao(solicitacao);
    setShowObservacao(true);
  }

  const cancelarSolicitacao = (motivo) => {
    if (motivo === "") {
      setMotivoVazio(true);
    } else {
      setEditado(false);
      const data = {
        "status": "cancelado",
        "observacao": motivo
      }
      servicosSolicitacao.cancelarSolicitacao(solicitacao.id_solicitacao, data).then(response => {
        if (response.status === 200) {
          setEditado(true);
        }
      })
      handleClose()
    }
  }

  const ModalEditar = () => {
    return <>
      <Modal className="modal-minhas-solicitacoes" show={show} onHide={handleClose}>
        <Modal.Body className="" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center mt-5">
                <div className="d-flex justify-content-start align-items-center row">
                  <span className="mb-1 text-center">Motivo Cancelamento:</span>
                  {motivoVazio && <span className="errosValidacao">Por favor, nos informe o motivo do cancelamento.</span>}
                  <textarea ref={motivo_cancelamento} id="motivo_cancelamento">
                  </textarea>
                  <span className="text-center">Você deseja realmente cancelar essa solicitação?</span>
                  <span className="text-center">Produto: <strong>{solicitacao?.Produto[0].nome}</strong></span>
                  <span className="text-center">Você receberá de volta M$: <strong>{solicitacao?.Produto[0].milhas}</strong></span>
                  <span className="w-100 mt-4 conjunto-btn text-center">
                    <button className="w-25 btn-icones rounded p-1 me-3" onClick={() => cancelarSolicitacao(motivo_cancelamento?.current?.value)}><Salvar /> Confirmar</button>
                    <button className="w-25 btn-icones rounded p-1" onClick={handleClose}><Cancel /> Voltar</button>
                  </span>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }

  const ModalObservacao = () => {
    return <>
      <Modal className="modal-lg " show={showObservacao} onHide={handleCloseObservacao}>
        <Modal.Body className="modal-edicao" >
          <div className="text-center mt-4">
            <span>Detalhes do envio</span>
            <textarea style={{ fontSize: 16 }} disabled className="w-100 h-100" defaultValue={solicitacao?.observacao ? solicitacao?.observacao : "Por enquanto nenhuma observação sobre o pedido foi adicionado."} id="observacao">
            </textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn-icones p-1 rounded " variant="secondary" onClick={handleCloseObservacao}>
            <Cancel /> Fechar
          </button>
        </Modal.Footer>
      </Modal>
    </>
  }

  const styleH3 = {
    color: "#753BBD",
    fontSize: "24px"
  }

  const columnsMinhasSolicitacoes = [
    { field: "id_solicitacao", headerName: "ID", width: 90 },
    {
      field: "Produto[0].nome",
      headerName: "Produto",
      width: 100,
      editable: true,
      valueGetter: (params) => {
        return params.row.Produto[0].nome
      }
    },
    {
      field: "Produto[0].tamanho",
      headerName: "Tamanho",
      width: 100,
      editable: false,
      valueGetter: (params) => {
        return params.row.Produto[0].tamanho
      }
    },
    {
      field: "milhas_solicitacao",
      headerName: "Qtd Milhas",
      width: 100,
      editable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      editable: false
    },
    {
      field: "observacao",
      headerName: 'Observação',
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <button className="btn-icones rounded p-1" onClick={() => handleShowObservacao(params.row)}><Edit /> Visualizar</button>;
      }
    },
    {
      field: "data_solicitacao",
      headerName: "Data Solicitação",
      width: 120,
      editable: false,
      valueGetter: (params) => {
        if (params.value !== null) {
          let aux = String(params.row.data_solicitacao).split("-");
          let ano = aux[0];
          let mes = aux[1];
          let dia = aux[2];
          let dataFormatada = `${dia}-${mes}-${ano}`;
          return dataFormatada;
        }
      }
    },
    {
      field: "data_entrega",
      headerName: "Data Entrega",
      width: 120,
      editable: false,
      valueGetter: (params) => {
        if (params.value !== null) {
          let aux = String(params.row.data_entrega).split("-");
          let ano = aux[0];
          let mes = aux[1];
          let dia = aux[2];
          let dataFormatada = `${dia}-${mes}-${ano}`;
          return dataFormatada;
        }
      }
    },
    {
      field: "responsavel",
      headerName: "Entregue por",
      width: 180,
      editable: true
    },
    {
      field: "Ação",
      headerName: <span className="ms-3">Ação</span>,
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return params.row.status === 'pendente' ? (<button className="btn-icones rounded p-1" onClick={() => handleShow(params.row)}><Cancel /> Cancelar</button>) : ('Finalizado')
      }
    }
  ];

  return <>
    <NavMenu />
    <ModalEditar />
    <ModalObservacao />

    <div className="container">
      <h3 style={styleH3} className="text-center subtitulo">Minhas Solicitações</h3>
      <div className="d-flex row justify-content-around align-items-center">
        <Box sx={{ height: 620, width: 1300, marginTop: 10.5 }}>
          <DataGrid

            style={{ borderRadius: "20px" }}
            localeText={localizedTextsMap}
            rows={minhasSolicitacoes}
            columns={columnsMinhasSolicitacoes}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            getRowId={(row) => row.id_solicitacao}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
            }
          />
        </Box>
      </div>
    </div>


    <NavMobile />
  </>
}

export default MinhasSolicitacoes;